import { useState } from "react";

function titleCase(str: string): string {
    return str
        .split(" ")
        .map((w) => {
            if (/^(dvm|vmd|bvsc|mvb)\.?$/i.test(w)) return w.toUpperCase();
            if (/^(dr|mr|ms|mrs)\.?$/i.test(w)) return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
            return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
        })
        .join(" ");
}

interface Props {
    onNext: (name: string) => void;
    defaultValue?: string;
}

export default function NameStep({ onNext, defaultValue = "" }: Props) {
    const [name, setName] = useState(defaultValue);

    const handleSubmit = () => {
        if (name.trim()) onNext(titleCase(name.trim()));
    };

    return (
        <div className="flex w-full max-w-[520px] flex-col items-center gap-10">
            <h1 className="fraunces-soft text-4xl font-semibold leading-tight text-shadow-700">What's your name?</h1>

            <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                placeholder="Dr. Sarah Chen"
                // eslint-disable-next-line jsx-a11y/no-autofocus -- sole input of this onboarding wizard step; autofocus is intentional UX
                autoFocus
                className="w-full rounded-xl border border-shadow-100 bg-white px-4 py-3.5 text-left text-lg text-shadow-700 placeholder:text-shadow-200 focused-inset"
            />

            <button
                onClick={handleSubmit}
                disabled={!name.trim()}
                className="w-full rounded-xl bg-max-900 py-3.5 text-lg font-semibold text-white hover:bg-max-850 disabled:bg-gray-100 disabled:text-gray-400 focused"
            >
                Continue
            </button>

            <p className="text-sm text-shadow-400">
                Press{" "}
                <kbd className="rounded border border-shadow-100 bg-shadow-25 px-1.5 py-0.5 font-mono text-xs">
                    Enter ↵
                </kbd>
            </p>
        </div>
    );
}
